//
import MdlBranchOffice from '../../../models/General/GBranchOffice'
import MdlCommissions from '../../../models/Sale/SlCommission'

export default [
    {
        name: 'rut',
        type: 'rut-input',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Rut',
            // rules: [required, numeric, isNotZero],
        },
    },
    {
        name: 'g_branch_office_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            chips: false,
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            model: MdlBranchOffice,
            noDataText: 'Sin Sucursales.',
            noObject: true,
            paramSearch: 'address',
            // rules: [required],
        },
    },
    {
        name: 'names',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Nombres',
            // rules: [required],
        },
    },
    {
        name: 'last_name1',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Primer Apellido',
            // rules: [required],
        },
    },
    {
        name: 'last_name2',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Segundo Apellido',
            // rules: [required],
        },
    },
    {
        name: 'email',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Correo Electrónico',
            // rules: [required, email],
        },
    },
    {
        name: 'seller_type',
        type: 'autocomplete',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            chips: false,
            itemText: 'name',
            itemValue: 'id',
            label: 'Tipo Vendedor',
            items: [
                {
                    id: 1,
                    name: 'Vendedor',
                },
                {
                    id: 2,
                    name: 'Vendedor a Terreno',
                },
                {
                    id: 3,
                    name: 'Vendedor Call Center',
                },
            ],
            // rules: [required],
        },
    },
    {
        name: 'commissions',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Comisiones',
            model: MdlCommissions,
            noDataText: 'Sin Comisiones.',
            noObject: true,
            paramSearch: 'name',
            multiple: true,
            clearable: false,
            // rules: [required],
        },
    },
]
